// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--2I-J2"};